module.exports = __webpack_public_path__ + "static/media/6.e02c5ab6.png";